import Footer from './FlightSummaryMetaFooter';

export default Footer;
